<template>
  <div class="modal-card mailer-preview-modal">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
      <button
        class="delete"
        type="button"
        aria-label="close"
        @click="cancel"
      ></button>
    </header>

    <section class="modal-card-body">
      <b-loading
        :is-full-page="false"
        :active.sync="loading"
        :can-cancel="false"
      ></b-loading>

      <b-message v-if="error" type="is-danger" has-icon>
        {{ error }}
      </b-message>

      <template v-if="!loading && !error">
        <table class="table is-fullwidth is-narrow mailer-preview-meta">
          <tbody>
            <tr>
              <th>Template</th>
              <td>
                <code>{{ templateId }}</code>
              </td>
            </tr>
            <tr>
              <th>Sample</th>
              <td>{{ sampleLabel }}</td>
            </tr>
            <tr>
              <th>Recipient</th>
              <td>
                <code>{{ toAddress }}</code>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="box" style="padding: 0.75rem 1rem; margin-bottom: 1rem">
          <p class="heading" style="margin-bottom: 0.25rem">Subject</p>
          <p class="title is-5" style="margin-bottom: 0">
            {{ subject || '(empty subject)' }}
          </p>
        </div>

        <p class="heading">Rendered HTML</p>
        <iframe
          title="SendWithUs preview"
          sandbox=""
          :srcdoc="html"
          class="mailer-preview-frame"
        ></iframe>
      </template>
    </section>

    <footer class="modal-card-foot">
      <button type="button" class="button" @click="cancel">Close</button>
      <a
        v-if="editUrl"
        class="button is-link"
        :href="editUrl"
        target="_blank"
        rel="noopener"
      >
        Edit
      </a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MailerPreviewModal',
  props: {
    previewUrl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      error: null,
      subject: null,
      html: '',
      sampleLabel: null,
      toAddress: null,
      templateId: null,
      editUrl: null,
    }
  },
  mounted: function () {
    this.reload()
  },
  methods: {
    cancel: function () {
      this.$emit('close')
    },
    reload: function () {
      this.loading = true
      this.error = null

      this.$secured
        .get(this.previewUrl, {
          headers: { Accept: 'application/json' },
        })
        .then((response) => {
          const data = response.data
          this.subject = data.subject
          this.html = this.withPreviewPadding(data.html || '')
          this.sampleLabel = data.sample_label
          this.toAddress = data.to_address
          this.templateId = data.template_id
          this.editUrl = data.edit_url
        })
        .catch((error) => {
          const message =
            (error.response &&
              error.response.data &&
              (error.response.data.error || error.response.data.alert)) ||
            error.message ||
            'Unable to render preview'
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
    withPreviewPadding: function (html) {
      if (!html) return ''

      if (/<\/head>/i.test(html)) {
        return html.replace(
          /<\/head>/i,
          '<style>body{padding:16px;margin:0;box-sizing:border-box}</style></head>'
        )
      }

      if (/<body[^>]*>/i.test(html)) {
        return html.replace(
          /<body([^>]*)>/i,
          '<body$1 style="padding:16px;margin:0">'
        )
      }

      return '<div style="padding:16px">' + html + '</div>'
    },
  },
}
</script>

<style scoped>
.mailer-preview-modal {
  width: 960px;
  max-width: calc(100vw - 2rem);
}

.modal-card-body {
  position: relative;
  min-height: 12rem;
}

.mailer-preview-meta {
  margin-bottom: 1rem;
  background: #fafafa;
}

.mailer-preview-meta th {
  width: 7.5rem;
  color: #7a7a7a;
  font-weight: 600;
  vertical-align: top;
  white-space: nowrap;
}

.mailer-preview-meta td {
  word-break: break-word;
}

.mailer-preview-frame {
  width: 100%;
  min-height: 55vh;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  background: #fff;
}
</style>
